/**
 * 储能模块 - 公共工具
 */

// ---- 数字格式化 ----

export function formatNum(val, maxDigits = 2) {
  if (val == null) return '--';
  let num = Number(val);
  if (Number.isNaN(num)) return '--';
  if (Math.abs(num) < 1e-10) num = 0;
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDigits,
  });
}

export function fmtCompact(v, digits = 2) {
  if (v == null || v === '') return '0';
  let n = Number(v);
  if (Number.isNaN(n)) return '0';
  if (Math.abs(n) < 1e-10) n = 0;
  return n.toFixed(digits).replace(/\.?0+$/, '') || '0';
}

export function toNum(v) {
  if (v == null || v === '') return 0;
  const n = Number(v);
  return Number.isNaN(n) ? 0 : n;
}

// ---- ECharts 配置 ----

const tooltip = {
  trigger: 'axis',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  borderColor: '#ebebf0',
  textStyle: { color: '#303133' },
};
const grid = { top: 10, right: 10, left: 50, bottom: 25 };

function axisMinMax(padding = 0.1) {
  return {
    min(v) {
      const span = v.max - v.min || 1;
      return +(v.min - span * padding).toFixed(2);
    },
    max(v) {
      const span = v.max - v.min || 1;
      return +(v.max + span * padding).toFixed(2);
    },
  };
}

function makeXAxis(data) {
  return {
    type: 'category',
    data,
    axisLine: { lineStyle: { color: '#d7d7d7' } },
    axisTick: { show: false },
    axisLabel: { color: '#909399', fontSize: 10 },
  };
}

function makeYAxis(extra = {}) {
  return {
    type: 'value',
    ...axisMinMax(),
    splitLine: { lineStyle: { color: '#ebebf0', type: 'dashed' } },
    axisLabel: { color: '#909399', fontSize: 10, formatter: v => (v % 1 === 0 ? v : v.toFixed(1)) },
    ...extra,
  };
}

function makeSeries(name, color, data, extra = {}) {
  return {
    name,
    type: 'line',
    smooth: true,
    data,
    itemStyle: { color },
    lineStyle: { width: 2 },
    showSymbol: false,
    ...extra,
  };
}

export function default24hLabels() {
  return Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, '0')}:00`);
}

export function singleLineOption(name, color, xData, yData, extra = {}) {
  return {
    tooltip,
    grid,
    xAxis: makeXAxis(xData),
    yAxis: makeYAxis(extra.yAxis),
    series: [makeSeries(name, color, yData, extra.areaStyle ? { areaStyle: extra.areaStyle } : {})],
  };
}

export function doubleLineOption(name1, color1, name2, color2, xData, y1Data, y2Data) {
  return {
    tooltip,
    grid,
    xAxis: makeXAxis(xData),
    yAxis: makeYAxis(),
    series: [makeSeries(name1, color1, y1Data), makeSeries(name2, color2, y2Data)],
  };
}

export function tripleLineOption(names, colors, xData, yDatas) {
  return {
    tooltip,
    grid,
    xAxis: makeXAxis(xData),
    yAxis: makeYAxis(),
    series: names.map((name, i) => makeSeries(name, colors[i], yDatas[i])),
  };
}
